import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[fileDragDrop]'
})
export class FileDragDropDirective {
  constructor(private el: ElementRef) {}

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.el.nativeElement.style.borderColor = '#2d388b';
    this.el.nativeElement.style.backgroundColor = '#f3f4f6';
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.el.nativeElement.style.borderColor = '#D1D5DB';
    this.el.nativeElement.style.backgroundColor = 'transparent';
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.el.nativeElement.style.borderColor = '#D1D5DB';
    this.el.nativeElement.style.backgroundColor = 'transparent';

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const fileInput = this.el.nativeElement.querySelector('input[type="file"]');
      if (fileInput) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(files[0]);
        fileInput.files = dataTransfer.files;

        // Trigger change event
        const changeEvent = new Event('change', { bubbles: true });
        fileInput.dispatchEvent(changeEvent);
      }
    }
  }
}

